import type { AllRouteEndpoints } from "../routeTypes";

export const engagementCampaignsConversionCorrelationDataCampaignId =
  "/engagement/campaigns/conversion_correlation_data/:campaign_id";

export const engagementCampaignsConversionCorrelationDataCampaignIdCacheKeys: AllRouteEndpoints[] = [];
